import { enableProdMode } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { $localize } from '@angular/localize/init';
import { bootstrapApplication } from '@angular/platform-browser';

import { logClientBootstrapPerformance } from '@usheru-hff/shared/utils';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

if (environment.mode == 'prod') {
  enableProdMode();
}

logClientBootstrapPerformance(() => bootstrapApplication(AppComponent, appConfig));
